// Icons

import HandshakeIcon from "@mui/icons-material/Handshake";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import HomeIcon from "@mui/icons-material/Home";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import SchoolIcon from "@mui/icons-material/School";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

// Langing pages

// Authentication Pages

import ForgetPasswordPage from "../app/auth/forget";
import ForgetPasswordVerification from "../app/auth/forget/ForgetPasswordVerification";
import ReEnterPasswordPage from "../app/auth/forget/ReEnterPassword";
import LoginPage from "../app/auth/login";
import SignupPage from "../app/auth/signUp";
import RegistrationVerification from "../app/auth/signUp/RegistrationVerification";

// Dashboard Pages

import UserDashboardPage from "../app/user/dashboard";
import UserEcommerceDetailPage from "../app/user/ecommerce";
import EducationChatWithAdminPage from "../app/user/educationDashboard/chat";
import UserEducationDashboardPage from "../app/user/educationDashboard/dashboard";
import EducatationDbFeesStructurePage from "../app/user/educationDashboard/feeStructure";
import EducationReportCardPage from "../app/user/educationDashboard/reportCard";
import EducationDbTimeTablePage from "../app/user/educationDashboard/timeTable";
import UserNotificationPage from "../app/user/notification";
import UserServiceTrackerPage from "../app/user/services";
import UserSettingPage from "../app/user/settings";
import UserAddressBookPage from "../app/user/addressBook";
import WalletHistoryPage from "../app/user/walletHistory";
import UserEcommercePackagePage from "../app/user/ecommercePackage";
import UserEcommerceAddEditPackagePage from "../app/user/ecommercePackage/AddEditPackage";
import UserWithdrawRequestPage from "../app/user/withdraw";

const APP_ROUTES = [
  {
    name: "home",
    path: "/",
    icon: <HomeIcon />,
  },
  {
    name: "allServices",
    path: "/all-service",
    icon: <MiscellaneousServicesIcon />,
  },
  {
    name: "educationCity",
    path: "/education-city",
    icon: <SchoolIcon />,
  },
  // {
  //   name: "E-com",
  //   path: "/e-commerce",
  //   icon: <ShoppingCartIcon />,
  // },
  {
    name: "pricing",
    path: "/pricing",
    icon: <LocalOfferIcon />,
  },
  {
    name: "helpCenter",
    path: "/help-center",
    icon: <HelpCenterIcon />,
  },
  {
    name: "becomePartner",
    path: "https://serviceprovider-f067a.web.app/",
    icon: <HandshakeIcon />,
  },
];

const AUTH_ROUTE = [
  {
    name: "logIn",
    path: "/login",
    component: <LoginPage />,
    icon: <LockOpenIcon />,
  },
  {
    name: "signUp",
    path: "/register",
    component: <SignupPage />,
    icon: <HowToRegIcon />,
  },
  {
    name: "Registration Verification",
    path: "/register/verification",
    component: <RegistrationVerification />,
    icon: null,
  },
  {
    name: "Forget Password",
    path: "/forget-password",
    component: <ForgetPasswordPage />,
    icon: null,
  },
  {
    name: "Forget Password Verification",
    path: "/forget-password/verification",
    component: <ForgetPasswordVerification />,
    icon: null,
  },
  {
    name: "New Password",
    path: "/forget-password/re-enter",
    component: <ReEnterPasswordPage />,
    icon: null,
  },
];

const DASHBOARD_ROUTES = [
  {
    name: "Dashboard",
    path: "/dashboard",
    component: <UserDashboardPage />,
    icon: null,
  },
  {
    name: "Education Dashboard",
    path: "/dashboard/education",
    component: <UserEducationDashboardPage />,
    icon: null,
  },
  {
    name: "User Ecomerce",
    path: "/dashboard/e-commerce",
    component: <UserEcommerceDetailPage />,
    icon: null,
  },
  {
    name: "User Services",
    path: "/dashboard/service",
    component: <UserServiceTrackerPage />,
    icon: null,
  },
  {
    name: "User Setting",
    path: "/dashboard/setting",
    component: <UserSettingPage />,
    icon: null,
  },
  {
    name: "User Notification",
    path: "/dashboard/notification",
    component: <UserNotificationPage />,
    icon: null,
  },
  {
    name: "User Address Book",
    path: "/dashboard/address-book",
    component: <UserAddressBookPage />,
    icon: null,
  },
  {
    name: "User Wallet History",
    path: "/dashboard/wallet-history",
    component: <WalletHistoryPage />,
    icon: null,
  },
  {
    name: "User Ecommerce Package",
    path: "/dashboard/ecommerce-package",
    component: <UserEcommercePackagePage />,
    icon: null,
  },
  {
    name: "User Ecommerce Package",
    path: "/dashboard/ecommerce-package/create",
    component: <UserEcommerceAddEditPackagePage />,
    icon: null,
  },
  {
    name: "User Withdraw Request",
    path: "/dashboard/withdraw-request",
    component: <UserWithdrawRequestPage />,
    icon: null,
  },
  {
    name: "User Education Fee Structure",
    path: "/dashboard/education/fee-structure",
    component: <EducatationDbFeesStructurePage />,
    icon: null,
  },
  {
    name: "User Education Time Table",
    path: "/dashboard/education/time-table",
    component: <EducationDbTimeTablePage />,
    icon: null,
  },
  {
    name: "User Education Chat",
    path: "/dashboard/education/chat",
    component: <EducationChatWithAdminPage />,
    icon: null,
  },
  {
    name: "User Education Report",
    path: "/dashboard/education/report",
    component: <EducationReportCardPage />,
    icon: null,
  },
];

export { APP_ROUTES, AUTH_ROUTE, DASHBOARD_ROUTES };
